import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import { InstitutionId } from "../../Types";
import ValidationError from "../../ZodError";
export const InstitutionCode = z.custom((val) => typeof val === "string");
const AcatsInstitution = z.object({
    acatsSystemName: z.string(),
    displayName: z.string(),
    institutionCode: InstitutionCode,
    institutionId: InstitutionId,
    searchTerms: z.string().array(),
});
const GetAcatsInstitutionsResponse = z.object({
    institutions: AcatsInstitution.array(),
});
export const url = () => environment() === "PROD"
    ? "https://middleware.prod.farther.com/transfer/v1/transfers/acats/institutions"
    : "https://middleware.uat.farther.com/transfer/v1/transfers/acats/institutions";
export default async function getAcatsInstitutions(config) {
    const { data } = await axios.get(url(), {
        headers: {
            Client: config.clientId,
            Authorization: `Bearer ${config.jwt}`,
            ...(config.advisorId && { Advisor: config.advisorId }),
        },
    });
    const decoded = GetAcatsInstitutionsResponse.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = `${getAcatsInstitutions.name} Could not parse.`;
        errorLog(getAcatsInstitutions.name, `Could not parse, ${decoded.error.message} ${JSON.stringify(decoded.error.issues)}`);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=getAcatsInstitutions.js.map